import {
  Box,
  Button,
  Card,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TrimPiece from "./TrimPiece";
import AddNewTrimDialog from "./AddNewTrimDialog";
import { v4 as uuidv4 } from "uuid";
import TextFieldDebouncedNoInitialLoad from "../../../../../components/TextFieldDebouncedNoInitialLoad";
import {
  currencyFormatNoDecimals,
  toTwoDecimals,
} from "../../../../../components/NewDetail/calculations/utils";
import AdornedInputDebouncedNoInitialLoad from "../../../../../components/AdornedInputDebouncedNoInitialLoad";

const BenchWork = ({
  isTollForm,
  defaultVariables,
  companyId,
  orderItem,
  onUpdate,
}) => {
  const [addTrimDialogOpen, setAddTrimDialogOpen] = useState(false);

  const onAddTrim = (newTrim) => {
    console.log("New BenchWork", newTrim);
    let piecesCopy = [...orderItem.benchWorkPieces];
    let newPieceDetails = {};
    newPieceDetails.benchPiece = newTrim;
    piecesCopy.push({
      quantity: 1,
      stretchOut: 1,
      ...newPieceDetails,
      // trim: newTrim,
      hits: 1,
      name: newTrim.name,
      image: newTrim.image,
      variables: { ...defaultVariables },
    });
    console.log("Piece Added", piecesCopy);

    onUpdate({
      ...orderItem,
      benchWorkPieces: piecesCopy,
    });
  };

  const onRemovePiece = (index) => {
    let piecesCopy = [...orderItem.benchWorkPieces];
    piecesCopy.splice(index, 1);

    onUpdate({
      ...orderItem,
      benchWorkPieces: piecesCopy,
    });
  };

  const onUpdateTrimPiece = (trimPieceIndex, updateObject) => {
    let piecesCopy = [...orderItem.benchWorkPieces];
    piecesCopy[trimPieceIndex] = {
      ...piecesCopy[trimPieceIndex],
      ...updateObject,
    };
    onUpdate({
      ...orderItem,
      benchWorkPieces: piecesCopy,
    });
  };

  if (orderItem)
    return (
      <Box>
        <Typography sx={{ flex: 1 }} variant="h6">
          Bench Work
          {orderItem.totalSellPrice !== undefined &&
          orderItem.totalSellPrice !== null
            ? ` - ${currencyFormatNoDecimals(
                Math.round(Number(orderItem.totalSellPrice ?? 0))
              )}`
            : ""}
        </Typography>

        <Box>
          <Box sx={{ marginTop: "8px", display: "flex", flexDirection: "row" }}>
            <TextField
              disabled
              sx={{ width: "100px" }}
              size="small"
              type="number"
              onFocus={(e) => e.target.select()}
              label="Flats Needed"
              value={
                orderItem.variables && orderItem.variables.flats_used
                  ? orderItem.variables.flats_used
                  : 0
              }
            />
            {!isTollForm && (
              <TextFieldDebouncedNoInitialLoad
                disabled
                sx={{ width: "150px", marginLeft: "8px" }}
                size="small"
                type="number"
                onFocus={(e) => e.target.select()}
                label="Material Cost"
                value={toTwoDecimals(
                  orderItem.benchWorkCalculations &&
                    orderItem.benchWorkCalculations.materialCost
                    ? orderItem.benchWorkCalculations.materialCost
                    : 0
                )}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            )}
            <Box sx={{ width: "150px", marginLeft: "8px" }}>
              <AdornedInputDebouncedNoInitialLoad
                disabled
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Labor Hrs."
                value={toTwoDecimals(
                  // orderItem.overrides.total_estimated_labor_hours !== null &&
                  //   orderItem.overrides.total_estimated_labor_hours !==
                  //     undefined
                  //   ? orderItem.overrides.total_estimated_labor_hours
                  //   : orderItem.benchWorkCalculations &&
                  //     orderItem.benchWorkCalculations.estimatedLaborHours
                  //   ? orderItem.benchWorkCalculations.estimatedLaborHours
                  //   : 0

                  orderItem.benchWorkCalculations &&
                    orderItem.benchWorkCalculations.totalEstimatedLaborHours
                    ? orderItem.benchWorkCalculations.totalEstimatedLaborHours
                    : 0
                )}
                onChange={(e) => {
                  let overrides = {
                    ...orderItem.overrides,
                    total_estimated_labor_hours: e.target.value,
                  };
                  onUpdate({
                    ...orderItem,
                    overrides,
                  });
                }}
                isOveridden={
                  orderItem.overrides &&
                  orderItem.overrides.total_estimated_labor_hours !== null &&
                  orderItem.overrides.total_estimated_labor_hours !== undefined
                }
                handleReset={() => {
                  let overrides = {
                    ...orderItem.overrides,
                    total_estimated_labor_hours: null,
                  };
                  onUpdate({
                    ...orderItem,
                    overrides,
                  });
                }}
              />
            </Box>

            <TextFieldDebouncedNoInitialLoad
              disabled
              sx={{ width: "150px", marginLeft: "8px" }}
              size="small"
              type="number"
              onFocus={(e) => e.target.select()}
              label="Est. Labor Cost"
              value={toTwoDecimals(
                orderItem.benchWorkCalculations &&
                  orderItem.benchWorkCalculations.totalEstimatedLaborCost
                  ? orderItem.benchWorkCalculations.totalEstimatedLaborCost
                  : 0
              )}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ marginRight: "4px" }}>
                    $
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Box
            sx={{ marginTop: "16px", display: "flex", flexDirection: "row" }}
          >
            <TextFieldDebouncedNoInitialLoad
              disabled
              size="small"
              type="number"
              onFocus={(e) => e.target.select()}
              label="Material & labor"
              symbol="$"
              position="start"
              value={toTwoDecimals(
                orderItem.benchWorkCalculations &&
                  orderItem.benchWorkCalculations.materialAndLabor
                  ? orderItem.benchWorkCalculations.materialAndLabor
                  : 0
              )}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ marginRight: "4px" }}>
                    $
                  </InputAdornment>
                ),
              }}
            />
            <TextFieldDebouncedNoInitialLoad
              sx={{ width: "150px", marginLeft: "8px" }}
              size="small"
              type="number"
              onFocus={(e) => e.target.select()}
              label="GP %"
              value={
                orderItem.variables && orderItem.variables.gross_profit_margin
                  ? toTwoDecimals(
                      orderItem.variables.gross_profit_margin * 100.0
                    )
                  : 0
              }
              onChange={(e) => {
                let variables = {
                  ...orderItem.variables,
                  gross_profit_margin: Number(e.target.value ?? 0) / 100.0,
                };
                onUpdate({
                  ...orderItem,
                  variables,
                });
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" sx={{ marginLeft: "4px" }}>
                    %
                  </InputAdornment>
                ),
              }}
            />
            <TextFieldDebouncedNoInitialLoad
              disabled
              sx={{ width: "150px", marginLeft: "8px" }}
              size="small"
              type="number"
              onFocus={(e) => e.target.select()}
              label="GP $"
              value={toTwoDecimals(
                orderItem.benchWorkCalculations &&
                  orderItem.benchWorkCalculations.grossProfitDollars
                  ? orderItem.benchWorkCalculations.grossProfitDollars
                  : 0
              )}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ marginRight: "4px" }}>
                    $
                  </InputAdornment>
                ),
              }}
            />

            <TextFieldDebouncedNoInitialLoad
              sx={{ width: "305px", marginLeft: "8px" }}
              disabled
              size="small"
              type="number"
              onFocus={(e) => e.target.select()}
              label="Suggested Total Price"
              value={toTwoDecimals(
                orderItem.benchWorkCalculations &&
                  orderItem.benchWorkCalculations.totalSellPrice
                  ? orderItem.benchWorkCalculations.totalSellPrice
                  : 0
              )}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ marginRight: "4px" }}>
                    $
                  </InputAdornment>
                ),
              }}
            />
            <TextFieldDebouncedNoInitialLoad
              sx={{ width: "305px", marginLeft: "8px" }}
              disabled
              size="small"
              type="number"
              onFocus={(e) => e.target.select()}
              label="Total Price"
              value={toTwoDecimals(
                orderItem.totalSellPrice ? orderItem.totalSellPrice : 0
              )}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ marginRight: "4px" }}>
                    $
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>

        <Box>
          {orderItem &&
            orderItem.benchWorkPieces &&
            orderItem.benchWorkPieces.map((piece, index) => {
              return (
                <TrimPiece
                  isTollForm={isTollForm}
                  trimType="BenchWork"
                  //key={piece.id ?? uuidv4()}  // This is causing the refresh. It only happens when the trim piece is unsaved
                  key={piece.id ?? `benchWorkPieces-${index}`} // Replace with something consistent
                  piece={piece}
                  onUpdatePiece={(updateObject) => {
                    onUpdateTrimPiece(index, updateObject);
                  }}
                  onRemovePiece={() => {
                    onRemovePiece(index);
                  }}
                />
              );
            })}
        </Box>
        <Box>
          <Button
            onClick={() => {
              setAddTrimDialogOpen(true);
            }}
          >
            + Add New
          </Button>
        </Box>
        <AddNewTrimDialog
          trimType="BenchWork"
          companyId={companyId}
          open={addTrimDialogOpen}
          handleClose={() => {
            setAddTrimDialogOpen(false);
          }}
          handleSubmit={(newTrim) => {
            onAddTrim(newTrim);
          }}
        />
      </Box>
    );
};

export default BenchWork;
